const testData = [
    {
        "id": 1, "text": "DJI", "headlessMode": true,"brushlessMotor": false,"foldable":true, "speed": 100
    },
    {
        "id": 2, "text": "HolyStone", "headlessMode": true,"brushlessMotor": true,"foldable":false, "speed": 200
    },

    {
        "id":3, "text": "JJRC", "headlessMode": false,"brushlessMotor": false,"foldable":false, "speed": 300
    },
    {
        "id":4, "text": "Potensic", "headlessMode": false,"brushlessMotor": true,"foldable":false, "speed": 400
    },


]

export default testData